import axios from "axios";

export default {
  getLogs(payload) {
    return axios.get(`/api/logs/${payload.type}/${payload.id}`);
  },
};
